import React from 'react'
import AddComent from '../AddComent/AddComent'
import Style from './AddCommentUserPanel.module.css'
const AddCommentUserPanel = () => {
    
    return (
        <ul className='pageHolder' style={{padding:0}}>
           <li className={Style.TitleHolder}><AddComent title={' نظرات و سوالات شما'}/></li> 
        </ul>
    )
}

export default AddCommentUserPanel
